<script>
import { MOLDURA_DO_THREAD } from '@modules/aawz-intelligence-v2/ui-registry/moldura-do-thread'
import { BLOCO_PERGUNTAS_ABERTAS } from '@modules/aawz-intelligence-v2/constants/TextChat'

/**
 * O texto da pergunta, venha ela como string (`parecer.perguntas_em_aberto` do
 * painel) ou como o objeto `{pergunta, porque}` da tool `perguntar_ao_gestor`.
 *
 * ★ As DUAS formas chegam a este cartão: é o que o contrato de UI declara (§3),
 * e a entrada `crm/perguntas-em-aberto` do `UI_REGISTRY` aponta para cá com as
 * duas origens no comentário (`ia/registry.js:15`). Sem normalizar, o objeto
 * renderiza `[object Object]` na tela — sem erro, sem warning, sem nada
 * vermelho (spec-001 `plataforma-por-chat`, [T017]).
 *
 * O canal onde o gestor RESPONDE é o `manager-questions`, não este: aqui é a
 * lista de leitura do parecer.
 *
 * Objeto sem `pergunta` devolve vazio de propósito — o `.filter(Boolean)` do
 * `itens` o descarta, e uma linha sem enunciado é pior que uma linha a menos.
 */
function textoDaPergunta(item) {
  if (typeof item === 'string') return item
  if (item && typeof item.pergunta === 'string') return item.pergunta
  return ''
}

export default {
  name: 'IntelligenceV2OpenQuestions',
  props: {
    // `parecer.perguntas_em_aberto` (`list[str]`) ou `output.perguntas` da tool
    // (`[{pergunta, porque?}]`) — ver `textoDaPergunta` acima.
    perguntas: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  // Moldura do thread pela constante compartilhada — mesmo contrato dos
  // outros donos legados; ver `ui-registry/moldura-do-thread.js`.
  data() {
    return { MOLDURA_DO_THREAD }
  },
  computed: {
    titulo() {
      return BLOCO_PERGUNTAS_ABERTAS.titulo
    },
    legenda() {
      return BLOCO_PERGUNTAS_ABERTAS.legenda
    },
    itens() {
      return this.perguntas
        .map(textoDaPergunta)
        .filter(Boolean)
        .map(function (texto, indice) {
          // Índice na chave: duas perguntas podem repetir o texto.
          return { chave: texto + '-' + indice, texto }
        })
    },
    // Lista vazia não vira card vazio (AC-6.9).
    temPerguntas() {
      return this.itens.length > 0
    },
  },
}
</script>

<template>
  <div v-if="temPerguntas" class="open-questions ia-block-card" v-bind="MOLDURA_DO_THREAD">
    <div class="ia-block-card__cabecalho ia-block-card__cabecalho--fita">
      <!-- `question` = o CircleHelp do protótipo. -->
      <icon-svg
        name="question"
        :size="14"
        color="var(--primary)"
        class="ia-block-card__icone"
      />
      <span class="ia-block-card__titulo">
        {{ titulo }}
      </span>
      <span class="ia-block-card__meta open-questions__legenda">
        {{ legenda }}
      </span>
    </div>

    <ul class="open-questions__lista">
      <li
        v-for="item in itens"
        :key="item.chave"
        class="open-questions__item"
      >{{ item.texto }}</li>
    </ul>
  </div>
</template>

<style lang="sass" scoped>
// Card, faixa, título e legenda vêm de `.ia-block-card*` (partial de módulo).
// Aqui fica só a lista de perguntas.

// ★ `display: block` NAO e redundante. A folha global tem `.content-nav ul
// { display: flex }` e o chat e renderizado dentro de `.content-nav` — sem
// reafirmar, as perguntas viravam COLUNAS lado a lado (medido: 5 itens de 82px
// numa lista de 706px). Pelo mesmo motivo o marcador e desenhado no ::before:
// o reset global `* { list-style: none }` mata o bullet nativo.
.open-questions__lista
  display: block
  margin: 0
  padding: 0
  list-style: none

// Separador ate a borda do card, como no prototipo — por isso a lista nao usa
// `.ia-block-card__corpo` e cada item paga o proprio padding.
.open-questions__item + .open-questions__item
  border-top: 1px solid var(--border-hairline)

.open-questions__item
  position: relative
  padding: 8px 14px 8px 26px
  font-size: var(--ia-font-auxiliar)
  line-height: 1.6
  color: var(--neutral-900)

  &::before
    content: ''
    position: absolute
    left: 14px
    top: 15px
    width: 4px
    height: 4px
    border-radius: 50%
    background: var(--primary)
</style>
